import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _AdquisitionItem, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { PrintJson } from "../../../../theme/Component/PrintJson";


interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

interface Resp {
    Obs: string;
    Approve: string;
}

export const BPM006 = ({ configProcedure }: Props) => {

    const { instance, bean, setBean } = useDataBean(_AdquisitionItem);
    const [props, setProps] = useState<any>({})

    const [response, setResponse] = useState<Resp>({
        Approve: "",
        Obs: ""
    })

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
    }, [configProcedure?._pocessData])


    const onExportMap = (responseData) => {
        console.log(responseData)
        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo(responseData.Obs)
        }

        if (configProcedure?._exportMap) {
            configProcedure?._exportMap(responseData)
        }
    }

    const handleApprove = (currentResponse: Resp) => {
        if (currentResponse.Obs.length > 15) {
            onExportMap(currentResponse);
        } else {
            toast.error("La justificación debe tener mínimo 15 caracteres");
        }
    };

    const handleDecline = (currentResponse: Resp) => {
        console.log(currentResponse)
        if (currentResponse.Obs.length > 15) {
            recazar(currentResponse);
        } else {
            toast.error("La justificación debe tener mínimo 15 caracteres");
        }
    };


    const recazar = (data) => {
        instance.changeAdquisitionItemApprovalNote(props.IDAdquisitionItem, _single.getAccountID(), response.Obs, props.PreparationState)
            .then(() => {
                onExportMap(data)
            })
            .catch(err => console.log(err));
    }

    const handleButtonClick = (approveValue: "true" | "false") => {
        const newResponse = { ...response, Approve: approveValue };
        setResponse(newResponse);
        if (approveValue === "true") {
            handleApprove(newResponse);
        } else {
            handleDecline(newResponse);
        }
    };

    return (
        <>
            <div className="row d-flex justify-content-between">
                <div className="col-md-12 mb-2">
                    <label>Observaciones</label>
                    <textarea className="form-control" value={response.Obs} onChange={(e) => { setResponse({ ...response, "Obs": e.target.value }) }} />
                </div>
                <div className="col-md-4">
                    <BasicButton icon="ri-checkbox-circle-line" eventClick={() => handleButtonClick("true")}>Aprobar</BasicButton>
                </div>
                <div className="col-md-4">
                    <BasicButton icon="ri-close-circle-line" eventClick={() => handleButtonClick("false")}>Rechazar</BasicButton>
                </div>
            </div>

        </>
    );
}